import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {Coroutine} from '../classes/coroutines/Coroutine.js';
import {CoroutineManager} from '../classes/coroutines/CoroutineManager.js';
import {Puzzle} from './puzzle.js';
import {GameFlowController} from './game-flow-controller.js';
import {TutorialSpawner} from './tutorial-spawner.js';
import {PopupWindowController, PopupWindowPanelStyle} from '../ui/panels/popup-window.js';
import {Localization} from '../utils/Localization.js';
import {waitForCondition, waitForSeconds} from '../classes/coroutines/YieldInstructions.js';
import {DropMode} from './puzzle-camera.js';
import {TutorialGameRules} from './tutorial-game-rules.js';
import {UIModel} from '../models/UIModel.js';
import {PowerupManager} from './powerup-manager.js';
import {BombButtonTutorial} from './bomb-button-tutorial.js';
import {TextManager} from '../classes/text-manager.js';
import {TutorialFingerTypes} from '../enums/TutorialFingerTypes.js';
import {WLUtils} from '../utils/WLUtils.js';
import {TimeManager} from './time-manager.js';
import {DefaultGameRules} from './rules/default-game-rules.js';
import {Statistics} from './statistics.js';
import {Analytics, AnalyticsEvent} from '../classes/Analytics.js';
import {StatNames} from '../enums/StatNames.js';
import {TransactionalNames} from '../enums/TransactionalNames.js';
import {AudioDirector} from './audio-director.js';
import {Sounds} from '../enums/Sounds.js';
import {MusicDirector} from './music-director.js';
import {ScoreController} from './score-controller.js';
import {UrgencyLevel} from '../enums/UrgencyLevel.js';

export class TutorialTextScript extends Component {
    static TypeName = 'tutorial-text-script';

    @property.object({required: true})
    popFinger!: Object3D;

    private _coroutineManager = new CoroutineManager();
    private _time = 0;

    start() {
        WLUtils.setActive(this.popFinger, false);
    }

    //TK: The original game started the tutorial spawning, but since in our game it
    // is already there we need to start it manually.
    startTutorial() {
        this._runTutorialId = this._coroutineManager.addCoroutine(
            new Coroutine(this.runTutorial())
        );
    }

    update(delta: number): void {
        this._coroutineManager.update(delta);
    }

    private _runTutorialId = 0;
    public *runTutorial() {
        const puzzle = Puzzle.instance;
        const hudModel = puzzle.score.HUDModel;
        const gameFlowController = GameFlowController.instance;

        const popup = PopupWindowController.instance;
        const puzzleCam = puzzle.mainCamera;
        puzzleCam.dropImmediateAllowed = false;
        puzzleCam.allowRotation = true;
        const originalDropSpeed = puzzle.dropSpeedFactor;

        yield* waitForCondition(() => TextManager.instance.isLoaded);
        yield* waitForCondition(() => puzzle.gameInProgress);

        UIModel.instance.setHUDActive(true);
        UIModel.instance.setTutorialHUDActive(true);

        gameFlowController.pause();

        // Make sure the texts are loaded before starting the tutorial

        yield* waitForCondition(() => gameFlowController.canChangeMenu);
        // Let's go!
        hudModel.setMalSpeech(TextManager.instance.getInGameTutorialText(0));
        popup.setPanel(PopupWindowPanelStyle.ingame);

        gameFlowController.unpause();

        //  spawner.spawn();
        //puzzle.spawner.paused = true;
        yield* waitForSeconds(2.0);
        hudModel.setMalSpeech('');
        yield* waitForSeconds(3.0);

        // stop the fruit from falling
        puzzle.dropSpeedFactor = 0;

        // 	Animation wordTween = wordBal.GetComponent<Animation>();
        // 	wordTween.Play("WordBalloonIn");
        yield* waitForCondition(() => gameFlowController.canChangeMenu);
        // How to rotate
        popup.show(Localization.instance.get('TutorialHowToRotate'), false);

        // spawn how to rotate finger
        hudModel.setTutorialFinger(TutorialFingerTypes.Rotation);
        puzzleCam.allowRotation = true;
        let lastLane = puzzleCam.findClosestLane();
        let laneCount = 0;
        // 	QualityControlManager.GetInstance().StartSampling();
        do {
            let currentLane = puzzleCam.findClosestLane();
            if (currentLane != lastLane) {
                laneCount++;
                lastLane = currentLane;
            }
            yield null;
        } while (laneCount < 2);
        // 	QualityControlManager.GetInstance().StopSampling();
        popup.hide();
        hudModel.setTutorialFinger(TutorialFingerTypes.None);
        // continue falling of the fruit
        puzzle.dropSpeedFactor = 3;

        yield* waitForSeconds(1.0);

        // Rotation skill learned!
        // how many blobs on the board?

        // "look out below!"
        // 	wordTween.Rewind();
        // 	wordTween.Play("WordBalloonIn");
        hudModel.setMalSpeech(TextManager.instance.getInGameTutorialText(1));

        //   let loadedObjectCount = puzzle.loadedObjectCount();
        // 	QualityControlManager.GetInstance().StartSampling();
        // Wait for first blob embed...
        //    yield* waitForCondition(() => puzzle.loadedObjectCount() != loadedObjectCount);
        // gameFlowController.pause();
        //  puzzle.spawner.paused = true;
        // 	QualityControlManager.GetInstance().StopSampling();
        //  yield* waitForCondition(() => gameFlowController.canChangeMenu);

        // // Fruit Blob Color Match, blob pop
        // popup.show(Localization.instance.get('TutorialHowToPop'), false);
        // // spawn how to pop finger
        // //hudModel.setTutorialFinger(TutorialFingerTypes.PopBlob);
        // WLUtils.setActive(this.popFinger, true);

        // const loadedObjPos = puzzle.findFirstLoadedObject();
        // const obj = puzzle.getObject(loadedObjPos.row, loadedObjPos.column);
        // this.popFinger.parent = obj.object;
        // this.popFinger.resetPositionRotation();

        // // 	QualityControlManager.GetInstance().StartSampling();
        // yield* waitForCondition(() => puzzle.objectCount() < startingNumberOfBlobs);

        // 	QualityControlManager.GetInstance().StopSampling();
        //puzzleCam.allowRotation = true;
        // "chain reaction!"
        // 	wordTween.Rewind();
        // 	wordTween.Play("WordBalloonIn");
        // hudModel.setMalSpeech(TextManager.instance.getInGameTutorialText(2));
        // // turn complete
        // BombButtonTutorial.instance.completeTurn();
        // hudModel.setTutorialFinger(TutorialFingerTypes.None);
        // popup.hide();
        // loadedObjectCount = puzzle.loadedObjectCount();
        // // 	// Popping skill learned!
        // puzzle.spawner.paused = false;

        // yield* waitForSeconds(1.2);
        // puzzle.spawner.paused = true;
        // yield* waitForCondition(() => gameFlowController.canChangeMenu);

        // Fast Drop
        //  hudModel.setMalSpeech('');
        popup.show(Localization.instance.get('TutorialFastDrop'), false);
        puzzleCam.dropImmediateAllowed = true;
        //puzzleCam.allowRotation = false;
        //gameFlowController.pause();
        puzzle.dropSpeedFactor = 0;
        // spawn how to drag fast finger
        hudModel.setTutorialFinger(TutorialFingerTypes.Swipe);
        yield* waitForCondition(() => puzzleCam.currentDropMode === DropMode.Immediate);

        hudModel.setTutorialFinger(TutorialFingerTypes.None);
        popup.hide();
        //gameFlowController.unpause();
        puzzle.dropSpeedFactor = 3;
        //puzzleCam.allowRotation = false;
        // "BOOM!"
        // hudModel.setMalSpeech(TextManager.instance.getInGameTutorialText(5));
        // turn complete
        //  BombButtonTutorial.instance.completeTurn();

        // Fast drop learned!
        //startingNumberOfBlobs = puzzle.objectCount();

        // "pop that blob!"
        // 	wordTween.Rewind();
        // 	wordTween.Play("WordBalloonIn");
        // hudModel.setMalSpeech(TextManager.instance.getInGameTutorialText(3));
        // // 	QualityControlManager.GetInstance().StartSampling();

        // // Wait for next chain
        // while (puzzle.objectCount() >= startingNumberOfBlobs) {
        //     BombButtonTutorial.instance.enabled = false;
        //     yield null;
        // }
        // // 	QualityControlManager.GetInstance().StopSampling();
        // BombButtonTutorial.instance.enabled = true;
        // puzzle.spawner.paused = true;
        // yield waitForSeconds(1.5);

        // hudModel.setTutorialFinger(TutorialFingerTypes.Powerup);
        // yield* waitForCondition(() => gameFlowController.canChangeMenu);

        // popup.show(Localization.instance.get('TutorialBombs'), false);
        // // "try out that powerup"
        // // 	wordTween.Rewind();
        // // 	wordTween.Play("WordBalloonIn");
        // hudModel.setMalSpeech(TextManager.instance.getInGameTutorialText(4));
        // yield* waitForCondition(() => puzzle.spawner.queueTop() != null);

        // hudModel.setTutorialFinger(TutorialFingerTypes.None);
        // popup.hide();
        // let loadedObjectCount2 = puzzle.loadedObjectCount();
        // puzzle.spawner.paused = false;
        // // 	QualityControlManager.GetInstance().StartSampling();
        // let beforeBombBlobs = puzzle.objectCount();
        // // 	// Wait for first blob embed...
        // yield* waitForCondition(() => puzzle.loadedObjectCount() != loadedObjectCount2);

        // // "BOOOOOOM"
        // // 	wordTween.Rewind();
        // // 	wordTween.Play("WordBalloonIn");
        // hudModel.setMalSpeech(TextManager.instance.getInGameTutorialText(5));

        // yield* waitForCondition(() => puzzle.objectCount() < beforeBombBlobs);

        // yield* waitForSeconds(0.5);
        // // 	QualityControlManager.GetInstance().StopSampling();

        // // tell more about bombs
        // popup.show(Localization.instance.get('TutorialBombsExplanation'), true);
        // yield* waitForCondition(() => !popup.isVisible);

        // const tutRules = puzzle.rules as TutorialGameRules;
        // tutRules.setTutorialDone();

        // //show winner text
        // puzzle.score.showMaxedLevelText();
        // hudModel.setMalSpeech('');

        // reset values
        Statistics.instance.record(StatNames.TutorialGamesPlayed, 1);
        MusicDirector.instance.play(Sounds.Song1Slow);
        Analytics.LogEventWithValue(AnalyticsEvent.GameRank, 0);
        Analytics.LogEvent(AnalyticsEvent.TutorialDone);
        puzzleCam.dropImmediateAllowed = true;
        puzzleCam.allowRotation = true;
        puzzle.dropSpeedFactor = originalDropSpeed;
        (puzzle.rules as DefaultGameRules).tutorialInProgress = false;
        //hudModel.setMalSpeech(TextManager.instance.getInGameTutorialText(5));
        yield* waitForSeconds(2.0);
        hudModel.setMalSpeech('');
        // 	Destroy(bombButtonRef);
        const firstPartDone = TimeManager.instance.time;

        // Let's keep the tutorial running so we can show a bomb finger when needed
        while (puzzle.gameInProgress) {
            yield null;

            // When are we showing the finger?
            // - Player reaches high urgency
            // - Player did not use a bomb before in the game
            // - Maybe also if the player has been playing for 2 or 3 minutes
            // Then, the finger should disappear after some time or
            // when the player uses a bomb.
            // How do we detect that? Just looking at the statistics every frame?
            // Also, we must make sure this keeps working when the game is paused
            // but stops working when the game is over.

            if (Statistics.instance.getLong(StatNames.BombUsed) > 0) {
                return;
            }

            const timePast = TimeManager.instance.time - firstPartDone;
            if (
                timePast >= 60 /*240*/ ||
                ScoreController.instance.urgency == UrgencyLevel.High
            ) {
                hudModel.setTutorialFinger(TutorialFingerTypes.Powerup);
                const fingerStartTime = TimeManager.instance.time;
                hudModel.setMalSpeech(TextManager.instance.getInGameTutorialText(5));
                yield* waitForCondition(
                    () =>
                        Statistics.instance.getLong(StatNames.BombUsed) > 0 ||
                        TimeManager.instance.time - fingerStartTime >= 10
                );

                //yield* waitForCondition(() => puzzle.objectCount() < beforeBombBlobs)
                hudModel.setTutorialFinger(TutorialFingerTypes.None);
                hudModel.setMalSpeech('');
                return;
            }
        }
    }
}
